// src/components/CtaBanner.js
// Reusable call-to-action banner used at the bottom of content pages.
import React from 'react';
import { Link } from 'react-router-dom';

const CtaBanner = ({ title, text, buttonLabel, to = '/contact' }) => (
    <div className="bg-primary">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 text-center" data-aos="zoom-in">
            <h2 className="text-3xl font-bold text-white mb-4">{title}</h2>
            {text && <p className="text-lg text-blue-50 mb-8 max-w-3xl mx-auto">{text}</p>}
            <Link
                to={to}
                className="inline-flex items-center justify-center bg-white text-primary hover:bg-gray-100 px-8 py-3 text-lg font-bold rounded-xl shadow-xl transition-colors"
            >
                {buttonLabel}
                <svg className="w-4 h-4 ml-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
            </Link>
        </div>
    </div>
);

export default CtaBanner;
